module.exports = __webpack_public_path__ + "img/2.9cb1a51d.svg";